<div class="custom-report-columns-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<div class="tab selected">{{ labels.lbl_report_columns_default }}</div>
	</div>
	<div class="body-wrap">
		<div class="dotted-input-container">
			<span>{{ labels.lbl_tipo_relatorio }}</span>
			<select [(ngModel)]="customPresetInterface.typePreset" (change)="getPresetsByType($event.target.value)">
				<option [value]="null" disabled="disabled">{{ labels.lbl_geral_selecione }}</option>
				<option [value]="'cmdb'">{{ labels.lbl_cmdb }}</option>
				<option [value]="'stock'">{{ labels.lbl_status_estoque }}</option>
				<option [value]="'request'">{{ labels.lbl_chamado }}</option>
			</select>
		</div>

		<cpi-input-with-autocomplete
			[placeholder]="labels.lbl_geral_buscar"
			[availableOptions]="listPresetsIAC"
			[minInputLength]="0"
			[setInputText]="setInputText"
			[cleanValues]="clearValuesPreset"
			[keepValue]="false"
			(onValueChange)="getPreset($event)"
			*ngIf="!isLoadingPresets">
		</cpi-input-with-autocomplete>

		<ng-container *ngIf="customPresetInterface.id != '-1' && !isLoadingTypeColumns">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_nome_predefinicao }} </span>
				<input
					type="text"
					[value]="customPresetInterface.namePreset"
					(input)="customPresetInterface.namePreset = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_observacoes }}</span>
				<textarea
					[rows]="2"
					[value]="customPresetInterface.notes"
					(input)="customPresetInterface.notes = $event.target.value"></textarea>
			</div>

			<cpi-generic-form-gen [setGenericForm]="configurationColumns" [labels]="labels" [columns]="2"> </cpi-generic-form-gen>
		</ng-container>

		<div class="button-container" *ngIf="customPresetInterface.typePreset !== ''">
			<div class="button" (click)="newPreset()">{{ labels.lbl_geral_novo }}</div>
			<div
				class="button red-trash-icon"
				[ngClass]="{ disabled: isUpdatingPreset || isDeletingPreset }"
				(click)="
					deleteListRef.classList.contains('confirm') ? deletePreset(this.customPresetInterface.id) : confirmButton(deleteListRef)
				"
				*ngIf="customPresetInterface.id !== '' && customPresetInterface.id != '-1'"
				#deleteListRef>
				{{ deleteListRef.classList.contains('confirm') ? labels.lbl_geral_confirmar : labels.lbl_geral_excluir }}
				<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isDeletingPreset"></cpi-dot-bounce-loading-effect>
			</div>
			<div
				class="button"
				[ngClass]="{ disabled: isUpdatingPreset || isDeletingPreset }"
				(click)="validateForm()"
				*ngIf="customPresetInterface.id != '-1'">
				{{ labels.lbl_geral_salvar
				}}<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingPreset"></cpi-dot-bounce-loading-effect>
			</div>
		</div>

		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingTypeColumns"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
